export default __webpack_public_path__ + "static/media/bannerMateri1.5c008908.webp";